module.exports = __webpack_public_path__ + "static/workshop-3e1d426fb5780fce3613ce0cce2f74a8.png";